export const MCC_DEF_GET ="/MccDef/GetAllMccDef"
export const MCC_DEF_INSERT = "/MccDef/InsertMccDef"
export const MCC_DEF_UPDATE = "/MccDef/UpdateMccDef"
export const MCC_DEF_DELETE = "/MccDef/DeleteMccDefByGuid"

export const MCC_ISO_RANGE_GET = "/MccIsoRangeDef/GetAllMccIsoRangeDef"
export const MCC_MASTERCARD_SERVİCE_CATEGORY_DEF_GET = "/MccMastercardServiceCategoryDef/GetAllMccMastercardServiceCategoryDef"
export const MCC_VISA_SERVICE_CATEGORY_DEF_GET = "/MccVisaServiceCategoryDef/GetAllMccVisaServiceCategoryDef"
export const MCC_NATIONAL_SWITCH_CATEGORY_DEF_GET = "/MccNationalSwitchCategoryDef/GetAllMccNationalSwitchCategoryDef"
export const MCC_GEOGRAPHY_TYPE_DEF_GET = "/MccGeographyTypeDef/GetAllMccGeographyTypeDef"

